import { SupplierInterface } from '../interfaces/supplier';

import { LinkedRequest } from '../interfaces/referrer';

export class Supplier implements SupplierInterface {
    IDSupplier?: number;
    Name: string;
    CF: string;
    Email: string;
    requests?: LinkedRequest[];

    constructor() {
        this.Name = '';
        this.CF = '';
        this.Email = '';
    }
}
